import { render, staticRenderFns } from "./List-Teacher.vue?vue&type=template&id=3b9cfe1c"
import script from "./List-Teacher.vue?vue&type=script&lang=js"
export * from "./List-Teacher.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./List-Teacher.vue?vue&type=style&index=1&id=3b9cfe1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports